import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Timestamp } from 'firebase/firestore';
import { Subscription } from 'rxjs';
import { stringToFirestoreTimestamp } from '../../../core/booking-from.utils';

@Component({
  selector: 'app-duration',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  template: `
    <div [formGroup]="duration" class="flex flex-col">
      <div class="flex flex-col">
        <h2 class="text-base font-semibold leading-7 text-gray-900">Dauer</h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">
          Datum, Start und Endzeit der Buchung angeben.
        </p>
      </div>
      <div
        class="mt-6 sm:mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-x-6"
      >
        <div>
          <label
            for="datum"
            class="block text-sm font-medium leading-6 text-gray-900"
            >Datum</label
          >
          <input
            id="datum"
            type="date"
            formControlName="date"
            class="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-columbus-blue-600 sm:text-sm sm:leading-6"
          />
        </div>
        <div>
          <label
            for="startTime"
            class="block text-sm font-medium leading-6 text-gray-900"
            >Start Time</label
          >
          <input
            id="startTime"
            type="time"
            formControlName="startTime"
            class="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-columbus-blue-600 sm:text-sm sm:leading-6"
          />

          <div
            *ngIf="patchGuidesToggle && guideAmount > 0"
            class="pt-3 sm:pt-4"
          >
            <button
              (click)="patchGuidesClick()"
              type="button"
              class="w-full sm:w-auto rounded-md bg-columbus-blue-600 px-3 py-2 sm:px-2.5 sm:py-1.5 text-sm font-semibold text-white shadow-xs hover:bg-columbus-blue-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-columbus-blue-600"
            >
              Update Guides
            </button>
          </div>
        </div>

        <div>
          <label
            for="endTime"
            class="block text-sm font-medium leading-6 text-gray-900"
            >End Time</label
          >
          <input
            id="endTime"
            type="time"
            formControlName="endTime"
            class="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-columbus-blue-600 sm:text-sm sm:leading-6"
          />
        </div>
      </div>
      <div class="mt-4 sm:mt-2 flex flex-row justify-start gap-x-6">
        <div class="w-full">
          <label
            for="tourCode"
            class="block text-sm font-medium leading-6 text-gray-900"
            >Tourcode</label
          >
          <input
            id="tourCode"
            type="text"
            formControlName="tourCode"
            class="mt-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-columbus-blue-600 sm:text-sm sm:leading-6"
            placeholder="Tourcode..."
          />
        </div>
      </div>
    </div>
  `,
  styles: ``,
})
export class DurationComponent implements OnInit, OnDestroy {
  @Input({ required: true }) duration!: FormGroup;
  @Input({ required: true }) guideAmount!: number;
  @Output() patchGuides = new EventEmitter<Timestamp>();

  startTimeSubscription: Subscription | undefined = undefined;
  patchGuidesToggle = false;
  initTime: string = '';

  ngOnInit(): void {
    const startTimeForm = this.duration.get('startTime');
    this.initTime = startTimeForm?.getRawValue() as string;
    if (startTimeForm) {
      this.startTimeSubscription = startTimeForm.valueChanges.subscribe(
        (value) => {
          if (this.initTime.localeCompare(value) && this.guideAmount > 0) {
            this.patchGuidesToggle = true;
          } else {
            this.patchGuidesToggle = false;
          }
        },
      );
    }
  }

  patchGuidesClick() {
    const dateStr = this.duration.get('date')?.getRawValue() as string;
    const timeStr = this.duration.get('startTime')?.getRawValue() as string;
    const time = stringToFirestoreTimestamp(dateStr, timeStr);

    this.initTime = this.duration.get('startTime')?.getRawValue() as string;
    this.patchGuidesToggle = false;
    this.patchGuides.emit(time);
  }

  togglePatchGuides() {
    this.patchGuidesToggle = !this.patchGuidesToggle;
  }
  ngOnDestroy(): void {
    this.startTimeSubscription?.unsubscribe();
  }
}
